import React from 'react';
import { useLocale, usePrefixCls } from '@byte-design/config';
import { Input } from '../../input';
import { Search } from './../../../common/icons';
export function SearchInput(props) {
  var localePlaceholder = useLocale('tree-select.placeholder');
  var search = props.search,
      onValueChange = props.onValueChange,
      inputRef = props.inputRef,
      _props$searchPlacehol = props.searchPlaceholder,
      searchPlaceholder = _props$searchPlacehol === void 0 ? localePlaceholder : _props$searchPlacehol;
  var cls = usePrefixCls('tree-search');
  return React.createElement("div", {
    className: cls
  }, React.createElement(Input, {
    prefix: React.createElement(Search, null),
    size: "md",
    clearable: true,
    value: search,
    placeholder: searchPlaceholder,
    onValueChange: onValueChange,
    needGrouped: false,
    inputRef: inputRef
  }));
}